import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "​", -1)
const _hoisted_2 = { class: "space-y-1" }
const _hoisted_3 = { class: "max-w-2xl text-sm text-gray-500 font-normal" }
const _hoisted_4 = { class: "mt-6" }
const _hoisted_5 = { class: "pt-4 flex items-center justify-end" }
const _hoisted_6 = {
  type: "submit",
  class: "focus:outline-none inline-flex justify-center rounded-md border border-transparent bg-yellow-600 px-5 py-2 text-base font-medium text-white shadow-sm hover:bg-yellow-600 focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2 sm:col-start-2 sm:text-sm"
}
const _hoisted_7 = { key: 0 }

import { Form, SubmissionHandler } from "vee-validate";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import * as yup from "yup";
import LoadingSpinner from "shared/components/loading_state/LoadingSpinner.vue";
import Modal from "shared/components/modals/Modal.vue";
import { useLoadAppUser } from "shared/composables/auth";
import { userRoles } from "shared/constants/user";
import InputField from "@/components/forms/InputField.vue";
import SelectListField from "@/components/forms/SelectListField.vue";
import UserRepository from "@/repositories/UserRepository";


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsUser',
  props: {
    open: { type: Boolean }
  },
  emits: ["closeUserSettingsModal"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();
const store = useStore();
const loadAppUser = useLoadAppUser();


const emit = __emit;

const updatePropertiesSchema = yup.object().shape({
  name: yup.string().required(t("authentication.validation.validation_field_required")),
  company: yup.string().required(t("authentication.validation.validation_field_required")),
  role: yup.string().required(t("authentication.validation.validation_field_required")),
});

const roleTypesList = userRoles.map((role) => ({
  value: role,
  name: t(`admin.project_participants.user_roles.${role}`),
}));

const isLoading = ref(false);

const initializeUserProperties = () => {
  const user = store.state.user;
  return {
    name: user.name,
    company: user.company,
    role: user.role || "",
  };
};

const handleSubmitUpdateUserProperties: SubmissionHandler = async (genericObject) => {
  isLoading.value = true;
  await UserRepository.updateOwnUserProperties(
    genericObject.name,
    genericObject.company,
    genericObject.role,
  );
  await loadAppUser();
  isLoading.value = false;
  emit("closeUserSettingsModal");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    class: "flex flex-1 items-stretch",
    open: _ctx.open,
    "custom-cls": "w-full lg:w-max",
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeUserSettingsModal')))
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t("admin.settings.user.title")), 1),
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("admin.settings.user.sub_title")), 1)
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Form), {
          onSubmit: handleSubmitUpdateUserProperties,
          initialValues: initializeUserProperties(),
          validationSchema: _unref(updatePropertiesSchema),
          class: "flex flex-col gap-2 w-full"
        }, {
          default: _withCtx(() => [
            _createVNode(InputField, {
              name: "name",
              label: _ctx.$t('admin.settings.user.name')
            }, null, 8, ["label"]),
            _createVNode(InputField, {
              name: "company",
              label: _ctx.$t('admin.settings.user.company')
            }, null, 8, ["label"]),
            _createVNode(SelectListField, {
              name: "role",
              label: _ctx.$t('admin.settings.user.role'),
              options: _unref(roleTypesList),
              minWidth: 250,
              placeholder: `--
              ${_ctx.$t('form.select_option')} --`
            }, null, 8, ["label", "options", "placeholder"]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", _hoisted_6, [
                (isLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (isLoading.value)
                        ? (_openBlock(), _createBlock(LoadingSpinner, {
                            key: 0,
                            size: "w-4 h-4",
                            color: "white"
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("form.update")), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["initialValues", "validationSchema"])
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})